import { ApiError } from "./api.js";

// Only errors proven to occur before creation may release the request key.
// A missing lookup, an unknown 4xx or a failed view response proves no such thing.
const REJECTED_BEFORE_CREATION: Readonly<Record<string, number>> = {
  UNAUTHENTICATED: 401,
  SESSION_EXPIRED: 401,
  ADMIN_SESSION_CLIENT_MISMATCH: 401,
  PASSWORD_CHANGE_REQUIRED: 403,
  STORY_NOT_FOUND: 404,
  STORY_ARCHIVED: 409,
  DOUBAO_CHARACTER_NOT_READY: 409,
  DIRECTOR_AGENT_EXTERNAL_REQUIRED: 409,
  OPENING_PREPARATION_STALE: 409,
  OPENING_PREPARATION_NOT_READY: 409,
  DOUBAO_CHARACTER_STORY_UNSUPPORTED: 422,
  STORY_PLAYTEST_NOT_READY: 422,
  PLAYABLE_CHARACTER_INVALID: 422,
  DIRECTOR_NARRATIVE_GRAPH_REQUIRED: 422,
  SIMULATION_SCENE_REQUIRED: 422,
};

export function playtestEntryWasRejected(caught: unknown): boolean {
  return caught instanceof ApiError && REJECTED_BEFORE_CREATION[caught.code] === caught.status;
}

export function playtestEntryFailureText(caught: unknown): string {
  if (caught instanceof ApiError && caught.code === "DIRECTOR_AGENT_EXTERNAL_REQUIRED" && caught.status === 409) {
    return "真实 AI 尚未就绪，本次未创建试玩。请检查模型连接、真实 AI 总开关和后台试玩开关；保存模型配置会关闭这些开关。";
  }
  return caught instanceof ApiError ? caught.message : "未能收到进入结果，请查询上次请求。";
}

export function playtestEntryQueryText(caught: unknown): string {
  return caught instanceof ApiError && caught.code === "PLAYTEST_NOT_FOUND" && caught.status === 404
    ? "当前账号暂未查到这次进入结果。请求记录已保留，查询不会重新创建试玩。"
    : caught instanceof ApiError ? caught.message : "暂时无法查询进入结果，请稍后再查询。";
}
